import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { normalizePatientInfo } from 'utils';
import { parse, format } from 'date-fns';
import common from 'constants/common';

const fullName = ({ title, firstName, middleName, lastName }) =>
  `${title || ''} ${firstName || ''} ${middleName || ''} ${lastName || ''}`;
const PersonalInfo = ({ profile }) => {
  let patientProfile = {};

  if (profile) {
    patientProfile = normalizePatientInfo(profile);
  }

  return (
    <Table borderless border="0" cellSpacing="0" cellPadding="0">
      <thead>
        <tr>
          <th colSpan="2">
            <div className="pagination-container">
              <h5>Personal Info</h5>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td />
          <td>
            <span>{fullName(profile)}</span>
            <span className="subheader">DOB:</span>
            <span>
              {format(
                parse(profile.birthDate, 'MM-dd-yyyy', new Date()),
                common.dateFormats.short,
              )}
            </span>
            <span className="subheader">G/L/R/E:</span>
            <span className="text-transform-none">
              {profile.gender || '-'}/{patientProfile.language || '-'}/
              {patientProfile.race || '-'}/{profile.ethnicity || '-'}
            </span>
            <span className="subheader">M/W</span>
            <span className="text-transform-none">
              {profile.martialStatus || '-'}/
              {patientProfile.workingStatus || '-'}
            </span>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

PersonalInfo.propTypes = {
  profile: PropTypes.shape().isRequired,
};

export default PersonalInfo;
